import {Injectable} from "@angular/core";

@Injectable()
export class InsuranceValidationsService {

    private errors:any={};

    public validate(form:any) {
        this.errors = {};
        let isValid = true;
        if(!this.validateForm(form)){
            isValid=false;
        }
        return {valid:isValid, errors:this.errors};
    }

    private reportError(key, obj) { this.errors[key]=obj; }

    private reportErrors(form: any) {
        Object.keys(form.controls).forEach((key) => {
            if(!!form.controls[key].errors){
                this.errors[key] = form.controls[key].errors;
            }
        })
    }

    private validateForm(form) : boolean{
        if(form.valid){
            return true;
        } else {
            this.reportErrors(form);
            return false;
        }
    }

}



// WEBPACK FOOTER //
// ./public/upgrade/feature/insurance/insurance-validations.service.ts